import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Row, Col } from "antd";
import ListaArquivos from "components/ListaArquivos";
import { ClienteContrato } from "core/features/cliente/typings";
import { TipoContrato } from "core/features/cliente/typings";
import ContentItem from "components/ContentItem";
import { formatMoney } from "infra/helpers/number";

interface ContentDetalhesContratoProps {
  item: ClienteContrato;
}

function ContentDetalhesContrato({ item }: ContentDetalhesContratoProps) {
  return (
    <>
      <Flex>
        <Heading size="md">Imóvel</Heading>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Matrícula do Imóvel"
            descricao={item?.matricula || "--"}
          />
        </Flex>

        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Tipo do Contrato"
            descricao={
              item?.tipoContrato === TipoContrato.Aluguel ? "Aluguel" : "Venda"
            }
          />
        </Flex>

        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo={"Valor do Aluguel"}
            descricao={`${formatMoney(item?.valor)}/mês` || "--"}
          />
        </Flex>

        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo={"Duração do Contrato"}
            descricao={item?.duracao || "--"}
          />
        </Flex>
      </Flex>

      <Flex>
        <Heading size="md">Corretor</Heading>
      </Flex>

      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Nome do Corretor"
            descricao={item?.nomeCorretor || "--"}
          />
        </Flex>

        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem titulo="CRECI" descricao={item?.creci || "--"} />
        </Flex>
      </Flex>

      <Flex>
        <Heading size="md">Taxas</Heading>
      </Flex>

      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Taxa de atraso"
            descricao={`${item?.taxaAtraso}%` || "--"}
          />
        </Flex>

        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Multa após 15 dias"
            descricao={`${item?.multa}%` || "--"}
          />
        </Flex>
      </Flex>

      <Flex>
        <Heading size="md">Regras</Heading>
      </Flex>

      {item?.regras.map((regra, index) => (
        <Flex py="4px" as={Row} gutter={8} key={regra.id}>
          <Flex as={Col} xs={24} flexDirection="column">
            <ContentItem
              titulo={`Regra${index + 1}`}
              descricao={regra.texto || "--"}
            />
          </Flex>
        </Flex>
      ))}

      <Flex>
        <Heading size="md">Anexos</Heading>
      </Flex>
      {item?.arquivos?.length ? (
        <>
          <Flex>
            <Heading mb={4} size="md">
              Arquivos
            </Heading>
          </Flex>
          <ListaArquivos arquivos={item?.arquivos || []} />
        </>
      ) : null}
    </>
  );
}

export default ContentDetalhesContrato;
